enum LoanKind {
  AutoKind,
  BasicLoanKind,
  SLRKind,
}

interface AutoType {
  kind: LoanKind.AutoKind
}

export function Auto() {
  const x: AutoType = { kind: LoanKind.AutoKind }
  return x
}

interface BasicLoanType {
  kind: LoanKind.BasicLoanKind
}

export function BasicLoan() {
  const x: BasicLoanType = { kind: LoanKind.BasicLoanKind }
  return x
}

interface SLRType {
  kind: LoanKind.SLRKind
}

export function SLR() {
  const x: SLRType = { kind: LoanKind.SLRKind }
  return x
}

export type Loan = AutoType | SLRType | BasicLoanType

export function equals(a: Loan, b: Loan) {
  return a.kind === b.kind
}
